import {
  authenticationCallback,
  smartChargingOrchestrationOrder,
} from "src/api/smartChargingClients";
import { Box, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Text from "src/components/Displays/Text";
import { EV_PATHS } from "src/consts/Routes/Ev";
import { SESSION_KEYS } from "src/consts/session";
import PrimaryButton from "src/components/Shared/PrimaryButton";
import { useSessionStorage } from "src/hooks/useSessionStorage";

const AddOn = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("translation");

  const [getCustomerAccess] = useSessionStorage<string>(
    SESSION_KEYS.MFE_CUSTOMER_ACCESS,
  );

  const initialCall = useCallback(async () => {
    const customerAccess = getCustomerAccess();
    if (!customerAccess) return;
    try {
      await authenticationCallback({
        xIsonCustomerToken: customerAccess,
        searchParams: window.location.search,
      });

      const responseOrder = await smartChargingOrchestrationOrder({
        xIsonCustomerToken: customerAccess,
      });

      setTimeout(() => {
        if (responseOrder.msgId === "Created") {
          navigate(EV_PATHS.EV_SUCCESS);
        } else {
          navigate(EV_PATHS.EV_FAILED);
        }
      }, 1000);
    } catch (e) {
      const error = e as Error;
      navigate(EV_PATHS.EV_FAILED + `?msgId=${error.msgId}`);
    }
  }, [getCustomerAccess, navigate]);

  useEffect(() => {
    initialCall();
  }, [initialCall]);

  return (
    <Stack gap={5}>
      <Text
        text={t("page.ev.addOn.pageTitle")}
        sx={(theme) => ({
          fontWeight: 500,
          fontSize: "32px",
          lineHeight: "40px",
          fontFamily: "officina",
          color: theme.palette.mainFont.primary,
        })}
      />

      <Text
        text={t("page.ev.addOn.pageSubTitle")}
        sx={(theme) => ({
          fontSize: "14px",
          fontWeight: "400",
          lineHeight: "20px",
          fontFamily: "Inter",
          color: theme.palette.mainFont.primary,
        })}
      />

      <Box>
        <PrimaryButton isLoading={true} text={t("page.ev.addOn.nextBtnText")} />
      </Box>
    </Stack>
  );
};

export default AddOn;
